import premiumHatImage from "@/assets/premium-cowgirl-hat.png";

interface PremiumHatOverlayProps {
  isPremium: boolean;
  isFoundingMember?: boolean | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-7 h-auto',
  md: 'w-9 h-auto',
  lg: 'w-12 h-auto',
};

const positionClasses = {
  sm: '-top-3 -right-3',
  md: '-top-4 -right-4',
  lg: '-top-5 -right-5',
};

export const PremiumHatOverlay = ({ 
  isPremium, 
  isFoundingMember, 
  size = 'sm',
  className = ""
}: PremiumHatOverlayProps) => {
  if (!isPremium) return null;
  
  // Founding members get a golden tint effect
  const foundingMemberFilter = isFoundingMember ? 'brightness-110 saturate-50 sepia' : '';
  
  return (
    <div 
      className={`absolute ${positionClasses[size]} z-20 ${className}`}
      style={{ transform: 'rotate(25deg)' }}
    >
      <img 
        src={premiumHatImage} 
        alt="Premium Member"
        className={`${sizeClasses[size]} drop-shadow-lg ${foundingMemberFilter}`}
        style={{ filter: `drop-shadow(0 2px 4px rgba(0,0,0,0.3)) ${isFoundingMember ? 'brightness(1.1) saturate(0.5) sepia(1)' : ''}` }}
      />
    </div>
  );
};
